export const ru = {
    billion: 'млрд',
    million: 'млн',
    quadrillion: 'квадрлн',
    quintillion: 'квинтлн',
    thousand: 'тыс.',
    trillion: 'трлн'
};
